import {
  LangOption,
  LanguageToggleNavItem,
  SelectedLangOption
} from './LanguageToggle.style';
import { Link } from 'react-router-dom';
import { Nav } from 'reactstrap';
import PropTypes from 'prop-types';
import React from 'react';

// Components

/**
 * Language Toggle component for login page.
 *
 * @param {Object} props All the properties passed to the React Component.
 * @returns {Element} Stateless functional React component.
 */
const LanguageToggle = ({
  isLoggedIn = false,
  langOptions = [],
  lang = 'en',
  clientCode,
  pathname
}) =>
  !isLoggedIn && (
    <Nav>
      <LanguageToggleNavItem>
        {langOptions.map(({ code }) =>
          lang === code ? (
            <SelectedLangOption key={code}>
              {code.toUpperCase()}
            </SelectedLangOption>
          ) : (
            <LangOption key={code}>
              <Link to={`/${code}/${clientCode}/${pathname}`}>
                {code.toUpperCase()}
              </Link>
            </LangOption>
          )
        )}
      </LanguageToggleNavItem>
    </Nav>
  );

LanguageToggle.contextTypes = {
  t: PropTypes.func.isRequired
};

export default LanguageToggle;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/LanguageToggle/LanguageToggleComponent.js